import * as FilterSettingsStore from './FilterSettingsStore';
import { takeEvery, select, put, call, take, race, all, fork } from "redux-saga/effects";
import { ApplicationState } from '../../store';
import { LoginState } from '../../login/loginStore';
import * as filterSettingsApi from '../../api/filterSettingApi';
import { FilterSettingsModel, getEmptyFilterSettingsModel } from '../../common/models/CommonModels';
import { localizations } from '../../localization/localization';
import { actions as rrfActions } from 'react-redux-form';
import { momentToDtoString } from '../../utils/dateUtilities';


// Store selectors
const getUserData = (state: ApplicationState) => state.login;

export function* watchSettingsSagas() {

    // Settings sagas
    yield takeEvery(FilterSettingsStore.ActionType.RequestFilterSettingsData, fetchFilterSettings);
    yield takeEvery(FilterSettingsStore.ActionType.AddOrEditFilterSetting, addFilterSetting);
    yield takeEvery(FilterSettingsStore.ActionType.updateNewFilterSettingsDestinationCities, updateNewFilterSettingsDestinationCities);
    yield takeEvery(FilterSettingsStore.ActionType.updateNewFilterSettingsDepartureCities, updateNewFilterSettingsDepartureCities);
    yield takeEvery(FilterSettingsStore.ActionType.updateNewFilterSettingsReporters, updateNewFilterSettingsReporters);
    yield takeEvery(FilterSettingsStore.ActionType.DeleteFilterSetting, deleteFilterSettingFlow);
}


function* updateNewFilterSettingsDestinationCities(action: FilterSettingsStore.UpdateNewFilterSettingsDestinationCitiesAction) {
    yield put(rrfActions.change("newFilterSetting.destinationCityIds", action.data));
}

function* updateNewFilterSettingsDepartureCities(action: FilterSettingsStore.UpdateNewFilterSettingsDepartureCitiesAction) {
    yield put(rrfActions.change("newFilterSetting.departureCityIds", action.data));
}

function* updateNewFilterSettingsReporters(action: FilterSettingsStore.UpdateNewFilterSettingsReportersAction) {
    yield put(rrfActions.change("newFilterSetting.reporters", action.data));
}


export function* fetchFilterSettings(action: FilterSettingsStore.RequestFilterSettingsDataAction): IterableIterator<any> {
    const filterSettingsList: any = yield call(loadFilterSettings);
    return filterSettingsList;
}



function* loadFilterSettings() {
    const { userId, companyId } = yield select(getUserData);
    const filterSettings: FilterSettingsModel[] = yield call(filterSettingsApi.getFilterSettings, companyId);

    yield put(FilterSettingsStore.actionsCreators.ReceivedFilterSettingsData(filterSettings));
    return filterSettings;
}


function* addFilterSetting(action: FilterSettingsStore.AddOrEditFilterSettingAction): IterableIterator<any> {
    let editMode = false;
    if (action.data) {
        // Load initial state for add edit form model.
        yield put(rrfActions.load("newFilterSetting", action.data));
        editMode = true;
    }

    // This action will inform UI to show add dialog.
    yield put(FilterSettingsStore.actionsCreators.addOrEditFilterSettingStarted(action.data));

    // Wait user input to submit or cancel adding.
    const { submit, cancel } : any = yield race({
        submit: take(FilterSettingsStore.ActionType.AddNewFormSubmitted),
        cancel: take(FilterSettingsStore.ActionType.AddNewFormCancelled)
    });

    if (submit) {
        const fSData: FilterSettingsModel = submit.data;

        const userData: any = yield select(getUserData);

        if (userData && userData.token) {

            const injected = Object.assign({}, fSData, {
                validFrom: momentToDtoString(fSData.validFrom),
                validTo: momentToDtoString(fSData.validTo),
                createdBy: userData.token.sub,
                companyId: userData.companyId
            });

            try {
                if (!editMode || fSData.id === "") {
                    const response = yield call(filterSettingsApi.addFilterSettings, injected);
                }
                else {
                    const response = yield call(filterSettingsApi.editFilterSettings, injected);
                }
            }
            catch (error) {
            }
        }
    }

    yield put(FilterSettingsStore.actionsCreators.addOrEditFilterSettingSuccess());
    yield put(rrfActions.load("newFilterSetting", getEmptyFilterSettingsModel()));

    if (action.afterAddOrEdit) {
        action.afterAddOrEdit();
    }

    yield call(loadFilterSettings);
}

function* deleteFilterSettingFlow(action: FilterSettingsStore.DeleteFilterSettingAction) {
    const filter = action.data;

    const success = yield call(filterSettingsApi.deleteFilterSetting, action.data);
    if (success) {
        const { userId, companyId } = yield select(getUserData);
        yield put(FilterSettingsStore.actionsCreators.RequestFilterSettingsData());
    }
}



// WEBPACK FOOTER //
// ./src/account/store/FilterSettingsSagas.ts